import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa en negocios o diseño?',
  a: 'No. El manual esta diseñado para mamas sin experiencia. Si sabes usar un telefono inteligente, puedes hacer esto. Las herramientas que enseñamos son gratuitas y el manual te lleva paso a paso desde cero.'
}, {
  q: '¿Cuanto tiempo necesito dedicarle por semana?',
  a: 'Para crear tu primer producto necesitas una tarde de 2-3 horas. Una vez configurado el sistema, puedes manejarlo con 3-5 horas a la semana. Muchas mamas lo hacen mientras sus hijos duermen.'
}, {
  q: '¿Necesito hablar ingles para vender?',
  a: 'No. El mercado objetivo son madres hispanas en EE.UU. que buscan material en español. Tu ventaja competitiva ES hablar español. Los anuncios, los productos y la comunicacion son en español.'
}, {
  q: '¿Como recibo el dinero de las ventas?',
  a: 'A través de plataformas de pago digital que depositan directamente en tu cuenta bancaria. El manual te explica exactamente cuáles usar y cómo configurarlas paso a paso.'
}, {
  q: '¿Que pasa si no funciona para mi?',
  a: 'Tienes 7 dias de garantia de devolucion completa. Si sientes que el producto no es lo que esperabas, escribenos y te devolvemos el dinero sin preguntas.'
}, {
  q: '¿Cuanto puedo ganar realistamente?',
  a: 'Los resultados varian segun el esfuerzo y consistencia. Algunas mamas generan $200-$500 en el primer mes. Con consistencia y los bonos de anuncios, $1,000-$2,000 mensuales es un objetivo alcanzable en 60-90 dias.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section style={{
    background: '#FAFAF6',
    padding: '80px 24px'
  }} data-id="element-1">
      <div style={{
      maxWidth: '760px',
      margin: '0 auto'
    }} data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        textAlign: 'center',
        marginBottom: '48px'
      }} data-id="element-3">
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(24px, 3vw, 38px)',
          fontWeight: 700,
          color: '#1C1C1E',
          marginBottom: '12px'
        }} data-id="element-4">
            Preguntas Frecuentes
          </h2>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '16px',
          color: '#4A4A4A'
        }} data-id="element-5">
            Respondemos las dudas mas comunes antes de que las tengas.
          </p>
        </motion.div>

        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }} data-id="element-6">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} style={{
          background: '#fff',
          borderRadius: '14px',
          border: '1px solid #E8DDD0',
          overflow: 'hidden',
          boxShadow: '0 2px 12px rgba(28,28,30,0.04)'
        }} data-id="element-7">
              <button onClick={() => setOpen(open === i ? null : i)} style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 24px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            gap: '16px'
          }} data-id="element-8">
                <span style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '15px',
              fontWeight: 700,
              color: '#1C1C1E',
              lineHeight: 1.4
            }} data-id="element-9">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: open === i ? 180 : 0
            }} transition={{
              duration: 0.25
            }} style={{
              flexShrink: 0
            }} data-id="element-10">
                  <ChevronDown size={18} style={{
                color: '#1B5E3B'
              }} data-id="element-11" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-12">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} style={{
              overflow: 'hidden'
            }} data-id="element-13">
                    <div style={{
                padding: '0 24px 20px',
                borderTop: '1px solid #F2EDE4'
              }} data-id="element-14">
                      <p style={{
                  fontFamily: "'Lato', sans-serif",
                  fontSize: '14px',
                  color: '#4A4A4A',
                  lineHeight: 1.75,
                  margin: '16px 0 0'
                }} data-id="element-15">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}